module.exports = __webpack_public_path__ + "c2d7514602ccdb0c461ee957c3d0b294.MP3";